export const EVENT_REDIRECTOR_URL = "https://eventsl.ink" as const;
export const LOCALSTORAGE_KEYS = {
	locale: `event-app:locale`,
	jetstreamCursor: `event-app:jetstream-cursor`,
	atprotoAccounts: `event-app:atproto-accounts`,
} as const;
